import React from 'react'
import Navbar from '../../components/Navbar'
import { Table,TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, Typography } from '@mui/material'; 
import Footer from '../../components/Footer'



function createData(name, qualification, Designation) {
    return { name, qualification, Designation };
  }
  
  const rows = [
    createData(
        "Mr. Ramanjineya R",
        "M.L.I.Sc, K-SET, AP-SET",
        "Librarian"
      ),
      
      createData(
        "Mr. Tabrej Pasha",
        "B.L.I.Sc (M.L.I.Sc)",
        "Assistant Librarian"
      ),
      createData(
        "Mrs. Nageena Begum",
        "B.L.I.Sc (M.L.I.Sc) M.Sc",
        "Assistant Librarian"
      ),
      
      createData("Mrs. Seilma Khatun", "PUC", "Library Attender"),
      createData("Mr. Abid Peran", "SSLC", "Library Attender"),
    ];

export default function Staffs() {
  return (
    <div>
        <Box top={0} position={'sticky'}><Navbar/></Box>
        <Box overflow={'hidden'} sx={{ zIndex:'-12', position: 'relative',  height: '50vh' }}>
        <img
            src={'/imgs/Bg1.jpg'}
            alt="Background "
            style={{
            objectFit:'cover',
            width: '100%',
            height: '100%',
            }}
        />
        
            <Typography variant='h3'   color={'#fff'}  sx={{py:2, backgroundColor:'rgba(0,0,0,0.5)',  position: 'absolute', bottom: 0, width:1 }}>
            Staffs
            </Typography>
        </Box>
        <Box display={'flex'} justifyContent={'center'} alignItems={'center'} m={3} >
            <TableContainer component={Paper} sx={{width:'fit-content', backgroundColor:'primary.main'}}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                    <TableRow>
                        <TableCell sx={{fontWeight:'bold',fontSize:'1rem'}}>Name</TableCell>
                        <TableCell sx={{fontWeight:'bold',fontSize:'1rem'}}>Qualification</TableCell>
                        <TableCell sx={{fontWeight:'bold',fontSize:'1rem'}}>Designation</TableCell>
            
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {rows.map((row) => (
                        <TableRow
                        key={row.name}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                        >
                       <TableCell >{row.name}</TableCell>
                        <TableCell >{row.qualification}</TableCell>
                        <TableCell >{row.Designation}</TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
      <Footer/>
    </div>
  )
}
